import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeJustificativaAlteracaoEncerrante,
  updateJustificativaAlteracaoEncerrante,
} from '~/store/modules/justificativaAlteracaoEncerrante/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.justificativaAlteracaoEncerrante
  );

  const initials = create ? data : { ...find, ...data };

  const optionsLB = useMemo(
    () => [
      { value: 'L', label: t('s.geral.opcoes.liberado') },
      { value: 'B', label: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          descricaojustificativaalteracaoencerrante: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50)),
          statusjustificativaalteracaoencerrante: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          ...initials,
          ...param,
          idcliente: client,
        };

        if (create) {
          dispatch(storeJustificativaAlteracaoEncerrante(objSend, params));
        } else {
          dispatch(updateJustificativaAlteracaoEncerrante(objSend, params));
        }
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [create, client, initials]
  );

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="descricaojustificativaalteracaoencerrante"
            label={t('s.relatorio.extratoproduto.descricao')}
          />

          <Select
            name="statusjustificativaalteracaoencerrante"
            label={t('s.configuracao.posto.statusposto')}
            options={optionsLB}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
